import { TooltipTrigger } from "@radix-ui/react-tooltip"
import type { IAccountReward } from "@apis/rewards/types"
import { useDrawer } from "@contexts/DrawerContext"
import { Tooltip, TooltipContent } from "@components/ui/tooltip"
import { RewardStatusBar } from "./RewardStatusBar"
import { RewardDetail } from "./RewardDetail"

type TAccountRewardsByTypeProps = {
  type: {
    rewards: IAccountReward[]
  }
  account_id: string
}

export function AccountRewardsByType({ type, account_id }: TAccountRewardsByTypeProps) {
  const { openDrawer } = useDrawer()

  return (
    <div className="tw:grid tw:grid-cols-1 tw:gap-6 tw:rounded-md tw:border tw:border-gray-300 tw:p-6">
      {type.rewards.map((reward, index) => {
        return (
          <div
            key={`${reward.description}-${index}`}
            className="tw:flex tw:gap-10 tw:rounded-md tw:border tw:border-gray-200 tw:p-4"
          >
            <div className="tw:w-50 tw:border-r tw:border-gray-200">
              <p className="mb-0">{reward.description}</p>
              {!reward.max_reward_amount && (
                <Tooltip>
                  <TooltipTrigger>
                    <strong>Reward Cap: {reward.max_reward_amount} $50</strong>
                  </TooltipTrigger>
                  <TooltipContent side="bottom" className="tw:max-w-38">
                    <span>
                      The max amount that can be redeemed for this reward.
                    </span>
                  </TooltipContent>
                </Tooltip>
              )}
            </div>

            <div
              className="tw:flex tw:flex-col tw:gap-2"
              onClick={() =>
                openDrawer(<RewardDetail reward={reward} account_id={account_id}/>, reward.title)
              }
            >
              <RewardStatusBar reward={reward} />
              <p className="tw:font-bold">{reward.status_summary}</p>
            </div>
          </div>
        )
      })}
    </div>
  )
}
